import React, {useContext} from 'react';
import {connect} from 'react-redux';
import {Modal} from '../../../components';
import * as Actions from '../../../store/actions';
import {EasyOnboardContext} from '../../../helpers/context';

function Confirmation({...otherProps}) {
  const {open, setOpen} = otherProps;
  const {widgetData, setWidgetData} = useContext(EasyOnboardContext);

  return (
    <Modal
      show={open}
      onClose={setOpen}
      setOpen={setOpen}
      extraModalClasses="max-w-[439px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center sm:justify-end"
      modalTitle="Configuration"
    >
      <div className="px-6 my-6">
        <p className="text-left text-body text-[15px] mb-6  ">
          Customize your confirmation text to the messaging of your choice.
        </p>

        <div className="flex flex-col  gap-3  py-[10px] ">
          <div className="flex flex-col">
            <span className="text-sm text-body flex items-center gap-2 ">
              Confirmation successful
            </span>
            <input
              type="text"
              id="success_message"
              className="mt-2 font-normal h-12 rounded-lg  text-sm"
              placeholder="Enter Confirmation successful..."
              value={widgetData?.success_message || ''}
              onChange={e =>
                setWidgetData({...widgetData, success_message: e.target.value})
              }
              maxLength={50}
            />
            <p className="text-end text-body text-sm font-medium mt-1">
              {widgetData?.success_message?.length || 0}/50
            </p>
          </div>

          <div className="flex flex-col">
            <span className="text-sm text-body flex items-center gap-2 ">
              Confirmation pending
            </span>
            <input
              type="text"
              id="pending_message"
              className="mt-2 font-normal h-12 rounded-lg  text-sm"
              placeholder="Enter Confirmation pending..."
              value={widgetData?.pending_message || ''}
              onChange={e =>
                setWidgetData({...widgetData, pending_message: e.target.value})
              }
              maxLength={50}
            />
            <p className="text-end text-body text-sm font-medium mt-1">
              {widgetData?.pending_message?.length || 0}/50
            </p>
          </div>

          <div className="flex flex-col">
            <span className="text-sm text-body flex items-center gap-2 ">
              Confirmation failed
            </span>
            <input
              type="text"
              id="failed_message"
              className="mt-2 font-normal h-12 rounded-lg  text-sm"
              placeholder="Enter Confirmation failed..."
              value={widgetData?.error_message || ''}
              onChange={e =>
                setWidgetData({...widgetData, error_message: e.target.value})
              }
              maxLength={50}
            />
            <p className="text-end text-body text-sm font-medium mt-1">
              {widgetData?.error_message?.length || 0}/50
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default connect(state => state, Actions)(Confirmation);
